import { render } from "./UserToplistTable.vue?vue&type=template&id=e5e3d86a&scoped=true"
import script from "./UserToplistTable.vue?vue&type=script&lang=js"
export * from "./UserToplistTable.vue?vue&type=script&lang=js"

import "./UserToplistTable.vue?vue&type=style&index=0&id=e5e3d86a&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5e3d86a"]])

export default __exports__